import React, {useEffect} from "react"
import {AdvertsContent} from "models/SearchState"
import {useReadFeatureSetting} from "../../contexts/useReadFeatureSetting"
import {FeatureSettingKeys} from "../../models/FeatureFlags"
import {AdsContainer} from "./components"
import {CMS_PAGE_ID, PARTIAL_VIEW_PLP} from "../../config/constants"

interface AdsProps {
    removeAdSpacerFromItems: () => void
    adsId: number | undefined
    advertsContent: AdvertsContent[]
}

export const Ads = ({removeAdSpacerFromItems, adsId, advertsContent}: AdsProps) => {
    // const coreMediaDomainURL = useReadFeatureSetting(FeatureSettingKeys.coremediaDomainUrl) as string
    const coreMediaRelativeUrl = useReadFeatureSetting(FeatureSettingKeys.coremediaRelativeUrl) as string
    const coreMediaAuthenticationTokenName = useReadFeatureSetting(
        FeatureSettingKeys.coremediaAuthenticationTokenName,
    ) as string
    const coreMediaAuthenticationTokenValue = useReadFeatureSetting(
        FeatureSettingKeys.coremediaAuthenticationTokenValue,
    ) as string
    const adsContainerId = `plp-ads-container-${adsId}`
    // Invoke NextAdsSdk
    useEffect(() => {
        const initAdsSdk = async () => {
            if (typeof window.NextAdsSdk !== "undefined") {
                try {
                    const urlParams = new URLSearchParams(window.location.search)
                    const fragmentID = urlParams.get(CMS_PAGE_ID) || ""
                    // If advertsContent is empty and fragmentID is not present, remove the ad spacer
                    // This is to avoid showing an empty ad container and to prevent unnecessary API calls
                    if (!advertsContent?.length && !fragmentID) {
                        removeAdSpacerFromItems()
                        return
                    }
                    const res = await window.NextAdsSdk.init({
                        coreMediaDomainURL: coreMediaRelativeUrl, // Use relative URL for CoreMedia for Pre Prod testing, if its works then place replace coreMediaDomainURL with coreMediaRelativeUrl
                        adsInjectionID: adsContainerId,
                        viewType: PARTIAL_VIEW_PLP,
                        fragmentID,
                        personalisationSlots: advertsContent,
                        coreMediaHeader: {
                            [coreMediaAuthenticationTokenName]: coreMediaAuthenticationTokenValue,
                        },
                    })
                    // Remove the ad spacer if the SDK initialization was not successful
                    if (!res.success) {
                        removeAdSpacerFromItems()
                    }
                } catch (error) {
                    removeAdSpacerFromItems()
                }
            } else {
                removeAdSpacerFromItems()
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        initAdsSdk()
    }, [])
    return <AdsContainer data-testid="cms-ads-container" id={adsContainerId} />
}
